// extracted by mini-css-extract-plugin
module.exports = {"root":"SendButton_root__2qvoQ"};